import TransitionModel from '../../../models/secure/TransitionModel';

// Payload required: { userId: value, csOrderNo: value }
const subscriberType = async (context, payload) => {
    let transitionModel = new TransitionModel();
    return transitionModel.subscriberType(payload).then(res => {
        let commitTarget = (res.data && res.data.status == TransitionModel.STATUS_SUCCESS) ? 'SET_SUBSCRIBER_TYPE' : 'CLEAR_SUBSCRIBER_TYPE';
        context.commit(commitTarget, res.data.records);
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

const subscribe = async (context, payload) => {
    let transitionModel = new TransitionModel();
    return transitionModel.subscribe(payload).then(res => {
        let commitTarget = (res.data && res.data.status == TransitionModel.STATUS_SUCCESS) ? 'SET_SUBSCRIBE_RESPONSE' : 'CLEAR_SUBSCRIBE_RESPONSE';
        context.commit(commitTarget, res.data.records);
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

const setTransitionUserId = (context, payload) => {
    context.commit('SET_TRANSITION_USERID', payload);
}

const setTransitionCsMatNo = (context, payload) => {
    context.commit('SET_TRANSITION_CSMATNO', payload);
}

const setTransitionCsOrderNo = (context, payload) => {
    context.commit('SET_TRANSITION_CSORDERNO', payload);
}

const setTransitionType = (context, payload) => {
    context.commit('SET_TRANSITION_TYPE', payload);
}

const clearStates = (context) => {
    context.commit('CLEAR_STATES');
};

export {
    subscriberType,
    subscribe,
    setTransitionUserId,
    setTransitionCsMatNo,
    setTransitionCsOrderNo,
    setTransitionType,
    clearStates
}
